<template>
  <v-container fluid class="user-management mt-4 px-1">
    <v-row>


      <template>


        <v-row justify="center">
          <v-dialog
              v-model="dialog"
              persistent
              max-width="500px"
          >


            <v-card>

              <v-alert
                  prominent
                  type="warning"
                  color="error"

              >
                <v-row align="center">
                  <v-col class="grow">
                    คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?
                  </v-col>

                </v-row>
              </v-alert>


              <v-card-text>
                <br>
                ขออภัยไม่สามารถลบรายการนี้ได้ เนื่องจากข้อมูลถูกอ้างอิงอยู่ หากต้องการลบข้อมูลโปรดติดต่อผู้ดูแลระบบ <br>
                หรือสามารถ <b style="color: red">ปิดการใช้งาน</b> รายการนี้ได้โดยคลิกที่ปุ่ม <b style="color:#536dfe;">ยืนยัน</b>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="default"
                    dark
                    @click="dialog = false"
                >
                  ยกเลิก
                </v-btn>
                <v-btn
                    color="primary"
                    dark
                    @click="confirmDelete"
                >
                  ยืนยัน
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>


      <v-col cols="12">

        <v-card class="mb-1" v-if="state=='view-edu'">

          <UserEduManagement
              id="User_UserEduManagement">

          </UserEduManagement>


          <v-alert
              border="top"
              colored-border
              color="success"
              elevation="2"
          >

            <v-row align="center">
              <v-col class="grow">
                <v-avatar>
                  <img
                      :src="baseURLStorage+temp_data.avatarFile"
                      :alt="temp_data.fname_th+' '+temp_data.lname_th"
                  >
                </v-avatar>

                สมาชิก <strong>{{ temp_data.email }}</strong> รหัสสมาชิก <strong>{{ temp_data.user_name }}</strong>
                ชื่อ-นามสกุล <strong>{{ temp_data.fname_th }} {{ temp_data.lname_th }}</strong>
              </v-col>
              <v-col class="shrink">
                <v-btn
                    color="primary"
                    outlined
                    class="button-shadow mr-4"
                    @click="close">
                  กลับสู่หน้าหลัก
                </v-btn>
              </v-col>
            </v-row>


          </v-alert>


        </v-card>


        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการสมาชิก</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + users.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items-per-page="15"
                :footer-props="{
                'items-per-page-options': [15, 25, 50,-1]
                }"
                :items="users"
                :search="search"
                sort-by="id">
              <template v-slot:top v-if="users.length>1">


<!--                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>-->


              </template>


              <template v-slot:item.avatarFile="{ item }">

                <v-avatar>
                  <img
                      :src="baseURLStorage+item.avatarFile"
                      :alt="item.fname_th+' '+item.lname_th"
                  >
                </v-avatar>


              </template>

              <template v-slot:item.disabled="{ item }">
                <span v-if="item.disabled == 1" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>

                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row justify="space-between">
                <v-col cols="6" sm="6">

                  <v-row align="center">

                    <v-col class="d-flex" cols="12" sm="6" v-if="state=='editForm'">
                      <v-text-field
                          v-model="editForm.user_name"
                          :counter="25"
                          :rules="editForm.textReqRules.concat(editForm.userNameRules)"
                          label="รหัสสมาชิก"
                          required
                          disabled
                      ></v-text-field>
                    </v-col>


                    <v-col class="d-flex" cols="12" sm="6" v-else>
                      <v-text-field
                          @keydown.space.prevent
                          v-model="editForm.user_name"
                          :counter="25"
                          :rules="editForm.textReqRules.concat(editForm.userNameRules)"
                          label="รหัสสมาชิก"
                          required
                      ></v-text-field>
                    </v-col>

                    <!-- @keydown.space.prevent ห้ามพิมช่องว่าง -->
                    <v-col class="d-flex" cols="12" sm="6" v-if="state=='editForm'">
                      <v-text-field
                          @keydown.space.prevent
                          v-model="editForm.email"
                          :rules="editForm.textReqRules.concat(editForm.emailRules)"
                          label="Email"
                          required
                          disabled
                      ></v-text-field>
                    </v-col>


                    <v-col class="d-flex" cols="12" sm="6" v-else>
                      <v-text-field
                          v-model="editForm.email"
                          :rules="editForm.textReqRules.concat(editForm.emailRules)"
                          label="Email"
                          required
                      ></v-text-field>
                    </v-col>

                  </v-row>

                  <v-row align="center">

                    <v-col class="d-flex" cols="12" sm="6">
                      <v-text-field
                          v-model="editForm.fname_th"
                          :rules="editForm.textReqRules"
                          label="ชื่อ(TH)"
                          required
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="6">
                      <v-text-field
                          v-model="editForm.lname_th"
                          :rules="editForm.textReqRules"
                          label="นามสกุล(TH)"
                          required
                      ></v-text-field>
                    </v-col>

                  </v-row>

                  <v-row align="center">

                    <v-col class="d-flex" cols="12" sm="6">
                      <v-text-field
                          v-model="editForm.fname_en"
                          :rules="editForm.textReqRules"
                          label="ชื่อ(EN)"
                          required
                      ></v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="6">
                      <v-text-field
                          v-model="editForm.lname_en"
                          :rules="editForm.textReqRules"
                          label="นามสกุล(EN)"
                          required
                      ></v-text-field>
                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col class="d-flex" cols="12" sm="4" v-if="state=='addForm'">

                      <v-col v-if="editForm.preview==''">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                          <v-col
                              class="text-subtitle-1 text-center"
                              cols="12"
                          >
                            เลือกไฟล์เพื่อแสดงผล
                          </v-col>
                          <v-col cols="6">
                            <v-progress-linear
                                color="deep-purple accent-4"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col v-else>
                        <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                      </v-col>


                    </v-col>

                    <v-col class="d-flex" cols="12" sm="8" v-if="state=='addForm'">

                      <v-file-input
                          @change="previewImage"
                          v-model="editForm.avatarFile"
                          show-size
                          chips
                          :rules="editForm.textReqRules.concat(editForm.imageRules)"
                          accept="image/*"
                          placeholder="Pick an avatar"
                          prepend-icon="mdi-camera"
                          label="ภาพโปรไฟล์"
                      ></v-file-input>


                    </v-col>


                    <v-col class="d-flex" cols="12" sm="4" v-if="state=='editForm'">

                      <v-card v-if="editForm.preview==''">
                        <v-img
                            :src="baseURLStorage+editForm.avatarFileOld"
                            :alt="editForm.fname_th+' '+editForm.lname_th"
                            style="max-width: 100%"
                        ></v-img>

                      </v-card>
                      <v-card v-else>
                        <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                      </v-card>


                    </v-col>

                    <v-col class="d-flex" cols="12" sm="8" v-if="state=='editForm'">

                      <v-file-input
                          @change="previewImage"
                          v-model="editForm.avatarFile"
                          show-size
                          chips
                          :rules="editForm.imageRules"
                          accept="image/*"
                          placeholder="Pick an avatar"
                          prepend-icon="mdi-camera"
                          label="ภาพโปรไฟล์ใหม่"
                      ></v-file-input>

                    </v-col>

                  </v-row>


                  <v-row align="center">


                    <v-col class="d-flex" cols="12" sm="12">
                      <v-checkbox
                          v-model="editForm.disabled"
                          true-value='Y'
                          false-value='N'
                          :rules="editForm.textReqRules"
                          label="ใช้งาน"
                          required
                      ></v-checkbox>
                    </v-col>

                  </v-row>


                </v-col>

                <v-col cols="6" sm="6">


                  <v-row align="center">

                    <v-col class="d-flex" cols="12" sm="12">
                      <v-text-field
                          v-model="editForm.phone_number"
                          label="โทรศัพท์(ใช้ในการติดต่อ)"
                      ></v-text-field>
                    </v-col>


                  </v-row>




                  <v-row align="center">


                    <v-col class="d-flex" cols="12" sm="12">
                      <v-text-field
                          v-model="editForm.job_title"
                          label="สาขา/สังกัด"
                      ></v-text-field>
                    </v-col>
                   

                  </v-row>


                  <v-row>

                    <v-col class="d-flex" cols="12" sm="12">
                      <v-row justify="end">
                        <v-btn
                            color="secondary"
                            outlined
                            class="button-shadow mr-4"
                            @click="cancelForm">
                          ยกเลิก
                        </v-btn>
                        <v-btn
                            color="primary"
                            outlined
                            class="button-shadow mr-4"
                            @click="reset"
                            v-if="state=='addForm'">
                          ล้างข้อมูล
                        </v-btn>
                        <v-btn
                            :disabled="!editForm.valid"
                            color="primary"
                            class="button-shadow mr-4"
                            @click="validate">
                          บันทึก
                        </v-btn>
                      </v-row>

                    </v-col>

                  </v-row>

                </v-col>

              </v-row>


            </v-form>
          </v-card-text>


        </v-card>
      </v-col>


    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';



export default {
  name: 'EquipmentUserManagement',
  data() {
    return {
      state: 'index',
      dialog: false,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      search: '',
      selected: [],
      headers: [

        {text: 'รูปโปรไฟล์', align: 'start', value: 'avatarFile'},
        {text: 'อีเมล์', value: 'email'},
        {text: 'รหัสสมาชิก', value: 'user_name'},
        {text: 'ชื่อ(TH)', value: 'fname_th'},
        {text: 'สกุล(TH)', value: 'lname_th'},
        {text: 'ชื่อ(EN)', value: 'fname_en'},
        {text: 'สกุล(EN)', value: 'lname_en'},
        {text: 'ประเภท', value: 'role'},
        {text: 'ใช้งาน', value: 'disabled'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        userNameRules: validateRules.userNameRules,
        emailRules: validateRules.emailRules,
        codeRules: validateRules.codeRules,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(3),
        user_name: null,
        email: null,
        fname_th: null,
        lname_th: null,
        fname_en: null,
        lname_en: null,
        avatarFile: null,
        avatarFileOld: null,
        preview: '',
        disabled: 'Y',
        phone_number: null,
        job_title: null,

      },
      temp_data: null,

    }
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('equipment_mem_user', ['users', "isReceiving", "isDeleting", "idToDelete", "userMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    userMessage() {

      if (this.userMessage !== '') {
        this.notification = this.userMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();

      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getUsersRequest();


  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('equipment_mem_user',
        [
          "getUsersRequest",
          "deleteUserRequest",
          "updateUserRequest",
          "createUserRequest"
        ]
    ),



    previewImage: function (event) {
      event == null ? this.editForm.preview = '' : this.editForm.preview = URL.createObjectURL(event)
    },

    addItem() {
      this.editedIndex = -1 //index = -1 add
      this.editForm.user_name = null;
      this.editForm.email = null;
      this.editForm.fname_th = null;
      this.editForm.lname_th = null;
      this.editForm.fname_en = null;
      this.editForm.lname_en = null;
      this.editForm.avatarFile = null
      this.editForm.disabled = 'Y';
      this.editForm.preview = '',
      this.editForm.phone_number = null,
      this.editForm.job_title = null,
      this.state = 'addForm';


    },
    editItem(item) {
      this.editedIndex = this.users.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.id = item.id;
      this.editForm.user_name = item.user_name;
      this.editForm.email = item.email;
      this.editForm.fname_th = item.fname_th;
      this.editForm.fname_en = item.fname_en;
      this.editForm.lname_th = item.lname_th;
      this.editForm.lname_en = item.lname_en;
      this.editForm.disabled = (item.disabled == 1 ? 'Y' : 'N');
      this.editForm.avatarFileOld = item.avatarFile;
      this.editForm.avatarFile = null,
      this.editForm.preview = '',
      this.editForm.phone_number = item.phone_number;
      this.editForm.job_title = item.job_title;
      this.state = 'editForm';


    },
    confirmDelete() {
      // this.deleteUserRequest({id: this.temp_data.id})
      this.temp_data.disabled = 'N'
      this.updateUserRequest(this.temp_data)
      this.dialog = false;
    },
    deleteItem(item) {
      this.temp_data = null;
      this.temp_data = item;
      this.dialog = true;

    },
    close() {
      if (this.errorMessage == false || this.userMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }

    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.users[this.editedIndex], this.editForm)
            :
            this.updateUserRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.users.push(this.editForm)
            :
            this.createUserRequest(this.editForm)
      }


    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },


  },
  async beforeMount() {
  },
  components: {

  },
}
</script>

<style src="./EquipmentUserManagement.scss" lang="scss"/>
